import React,{useState,useEffect} from 'react';
import { Image} from 'react-bootstrap';
import { useSpring, a } from '@react-spring/web'

function FlipCard(props) {

  var c = "cover";
  if (props.flipped){
    c = props.card;
  }
  const [currentCard, setCard] = useState(c);
  const [flipped, flipCard] = useState(props.flipped);
  
  const { transform, opacity } = useSpring({
    opacity: (flipped) ? 1 : 0,
    transform: `perspective(calc(${props.width}*2)) rotateY(${(flipped) ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 }
  })

  useEffect(() => {
    if (props.card != currentCard){
      flipCard(false); //Shuffle, flip back to cover
    }
  },[props.card, currentCard] );
  
  function handleClick(){
    if (!props.draggable){
      if (flipped == false){
        setCard(props.card);
        flipCard(true);
        setCard(props.card);
        props.onClick(false);
      }
      else{
        //Click on card, show commentary
        props.onClick(true);
      }
    }
  }

  var currentCardPath = "cards/" + currentCard + ".jpg";
  
  return (
     <div>
          <div className="cardno" style={{opacity:1}}>{props.cardno}</div>
          <a.div onClick={handleClick} className="c back" style={{cursor:'pointer', position:'absolute', display: 'inline-block', width:`${props.width}`, minWidth:`${props.minWidth}`, opacity: opacity.to(o => 1 - o), transform }}>
              <Image src="cards/cover.jpg" thumbnail style={{overflow:'hidden', zOrder:99, height: `${props.height}`, maxHeight: `${props.maxHeight}`,width:`${props.width}`,minWidth:`${props.minWidth}`}} />
          </a.div>
          <a.div onClick={handleClick} className="c front" style={{cursor:'pointer', position:'absolute', display: 'inline-block', width:`${props.width}`, minWidth:`${props.minWidth}`, opacity,transform,rotateY: '180deg'}}>
              <Image src={currentCardPath} thumbnail style={{overflow:'hidden', zOrder:99, height: `${props.height}`, maxHeight: `${props.maxHeight}`, minWidth:`${props.minWidth}`}} />
          </a.div>
      </div>
  )
};

export default FlipCard;